var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M960 96a64 64 0 0 1 64 64v704a64 64 0 0 1-64 64H64a64 64 0 0 1-64-64v-704a64 64 0 0 1 64-64z m-8 256H72A8 8 0 0 0 64 360v488c0 8.768 7.232 16 16 16h864a16 16 0 0 0 16-16V360a8 8 0 0 0-8-8zM584.32 496a32 32 0 0 1 13.184 43.328l-114.56 214.976a31.872 31.872 0 1 1-56.32-30.08l114.368-215.04a32 32 0 0 1 43.328-13.184z m129.152 44.16l61.248 61.248a32 32 0 0 1 0 45.312l-61.248 61.184a4.096 4.096 0 0 1-5.696-0.128l-39.552-39.552a3.968 3.968 0 0 1 0-5.76l27.2-27.136a16 16 0 0 0 0-22.656l-27.2-27.2a3.968 3.968 0 0 1 0-5.696l39.552-39.552a3.968 3.968 0 0 1 5.76 0z m-397.248 0l39.552 39.552a3.968 3.968 0 0 1 0 5.696l-27.2 27.2a16 16 0 0 0 0 22.592l27.2 27.2a3.968 3.968 0 0 1 0 5.76l-39.552 39.552a3.904 3.904 0 0 1-5.76 0.064l-61.184-61.184a32 32 0 0 1 0-45.312l61.248-61.184a3.968 3.968 0 0 1 5.696 0zM944 160H80a16 16 0 0 0-16 16v104c0 4.416 3.584 8 8 8h880A8 8 0 0 0 960 280V176a16 16 0 0 0-16-16z m-96 32a32 32 0 1 1 0.064 63.936A32 32 0 0 1 848 192z m-128 0a32 32 0 1 1 0.064 63.936A32 32 0 0 1 720 192z m-128 0a32 32 0 1 1 0.064 63.936A32 32 0 0 1 592 192z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowser);
export default __webpack_public_path__ + "static/media/browser.97ddf498.svg";
export { ForwardRef as ReactComponent };